import truncate from 'utils/global/truncate'
import * as S from './TableLite.styled'

export const TableLiteCell = ({ text, truncate: length = 22, ...props }) => (
  <S.CellText {...props}>
    {text?.length < length || !text ? text : truncate(text, length)}
  </S.CellText>
)

export default TableLiteCell
